<template>
  <section id="website-dashboard">
    <div class="section padding-page-top padding-bottom over-hide">
      <div class="container ">
        <div class="row page-title px-4 px-xl-2">
          <div class="col-12 parallax-fade-top">
            <h1>Case Study Portal</h1>
          </div>
          <div class="offset-1 col-11 parallax-fade-top mt-2 mt-sm-3">
            <p>
              <span class="ml-4 ml-xl-5">Add and Remove Case Studies</span>
            </p>
          </div>
        </div>

        <form action="" @submit.prevent="saveWebsite">
          <fieldset
            class="col-12"
            :disabled="submitting"
            :class="{ 'no-pointer': submitting }"
          >
            <div class="ajax-form">
              <div class="col-md-12">
                <input
                  v-model="form.name"
                  name="name"
                  type="text"
                  placeholder="Project Name: *"
                  autocomplete="off"
                />
              </div>
              <div class="col-md-12 mt-4">
                <input
                  v-model="form.url"
                  name="url"
                  type="text"
                  placeholder="Project URL: *"
                  autocomplete="off"
                />
              </div>
              <div class="col-md-12 mt-4">
                <input
                  v-model="form.image"
                  name="url"
                  type="text"
                  placeholder="Enter Cover Image URL: *"
                  autocomplete="off"
                />
              </div>

              <div class="col-md-12 mt-4">
                <button :class="{ submitting: submitting }">
                  <span>submit</span>
                </button>
              </div>
              <div v-if="error" class="col-md-12 mt-4">
                <p>{{ error }}</p>
              </div>
            </div>
          </fieldset>
        </form>

        <div class="col-12 mt-5">
          <transition name="slide" mode="out-in">
            <CaseStudyModify />
          </transition>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { EventBus } from "../main";
import { ParallaxEffect } from "@/components/utils";
import CaseStudyModify from "@/components/CaseStudyModify";
import { mapGetters } from "vuex";

import { caseStudyCollection } from "../firebase-config";

export default {
  data() {
    return {
      loading: false,
      form: {
        name: null,
        url: null,
        image: null
      },
      blankForm: {
        name: null,
        url: null,
        image: null
      },
      error: null,
      submitting: false
    };
  },
  computed: {
    ...mapGetters(["currentUser", "userProfile"])
  },
  components: {
    CaseStudyModify
  },
  methods: {
    async saveWebsite() {
      this.submitting = true;
      this.error = null;
      try {
        await caseStudyCollection.add({
          createdOn: new Date(),
          url: this.form.url + "?iframe=1",
          name: this.form.name,
          userId: this.currentUser.uid,
          creator: this.userProfile.name,
          image: this.form.image
        });
        this.form = this.blankForm;
      } catch (err) {
        console.log(err);
        this.error = err.message;
      } finally {
        this.submitting = false;
      }
    }
  },
  mounted() {
    EventBus.$emit(
      "allLinks",
      document.querySelectorAll("textarea, button, .mark-delete")
    );
    ParallaxEffect(this.$el);
  }
};
</script>

<style lang="scss" scoped>
fieldset {
  &.no-pointer {
    pointer-events: none;
  }
  .ajax-form {
    transition: transform 0.5s;
    transform-origin: center;

    input,
    textarea {
      position: relative;
      width: 100%;
      padding: 20px 20px;
      font-weight: 400;
      letter-spacing: 1px;
      font-size: 15px;
      line-height: 1.7;
      background-color: #14151a;
      color: #fff;
      border: none;
      text-align: left;
      cursor: text;
      transition: all 250ms linear;

      &:active,
      &:hover {
        color: #ccc;
      }

      &:focus {
        outline: none !important;
      }

      &::placeholder {
        font-size: 15px;
        letter-spacing: 1px;
        color: rgba(255, 255, 255, 0.4);
        font-weight: 700;
      }

      &::selection {
        background: $primary;
      }
    }

    button {
      color: rgba(255, 255, 255, 0.5);
      cursor: pointer;
      font-size: 15px;
      padding: 12px 25px;
      letter-spacing: 2px;
      background-color: #14151a;
      border: none;
      outline: none;
      margin: 0 auto;
      text-align: center;
      min-height: 30px;
      transition: all 250ms linear;

      &.submitting {
        width: 30px;
        padding: 0;
        border-radius: 500px;
        border: 5px solid $primary;
        border-top-color: black;
        border-bottom-color: black;
        animation: rotate 1.2s cubic-bezier(0.77, 0, 0.175, 1) infinite;

        @keyframes rotate {
          to {
            transform: rotate(360deg);
          }
        }
        & span {
          opacity: 0;
          display: none;
        }
      }

      &:focus,
      &:active {
        border: none;
        outline: none;
      }
      &:hover {
        background-color: $primary;
        color: black;
      }
      span {
        position: relative;
        display: block;
        cursor: pointer;

        transition: all 250ms linear;
      }
    }
  }
}
.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: 0.3s all ease;
}
</style>
